"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustomMetadataHead = void 0;
var _head = _interopRequireDefault(require("next/head"));
var _jsxRuntime = require("react/jsx-runtime");
const CustomMetadataHead = ({
  customMetaData
}) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_head.default, {
  children: customMetaData.map((metaItem, index) => /*#__PURE__*/(0, _jsxRuntime.jsx)("meta", {
    name: metaItem.name,
    content: metaItem.content
  }, index))
});
exports.CustomMetadataHead = CustomMetadataHead;
